import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a01d50df6558f0014483b15_1781802541930_e7d8df7a/teamos/src/app/sign-up-login/components/AuthScreen.tsx");
